import { BaseSocketService } from './baseSocketServiceSocketIO';

class TestResultServiceSocketIO extends BaseSocketService {
    listeners: { [resultId: string]: (data: any) => void } = {};

    init(projectId: string) {
        super.init(projectId, 'testResult');
        this.listeners = {};
    }

    listenToTestResult(resultId: string, testId: string, onTestResultStatus: (testResult: any) => void) {
        if (this.listeners[resultId]) {
            this._socket!.off('testResult:updated', this.listeners[resultId]);
            delete this.listeners[resultId];
        }

        this.listeners[resultId] = data => {
            if (data.resultId === resultId && data.testId === testId) {
                onTestResultStatus(data.testResult);
            }
        };

        this._socket!.on('testResult:updated', this.listeners[resultId]);
    }

    override emitJoinRoom(resultId: string, testId: string) {
        return this.emitPromise('testResult:join', {
            resultId,
            testId,
        });
    }

    async joinToTestResult(resultId: string, testId: string) {
        if (!this.rooms[resultId]) {
            this.joinRoom(resultId, testId);
        }
        await this.emitJoinRoom(resultId, testId); //we want to always emit "join room" incase we reconnected to a new ws service instance
    }

    emitLeaveRoom(resultId: string, testId: string) {
        return this.emitPromise('testResult:leave', {
            resultId,
            testId,
        });
    }

    leaveTestResult(resultId: string, testId: string) {
        if (!this.listeners[resultId]) {
            return Promise.resolve();
        }

        this.leaveRoom(resultId);
        this._socket!.off('testResult:updated', this.listeners[resultId]);
        delete this.listeners[resultId];
        return this.emitLeaveRoom(resultId, testId);
    }

    getSocket() {
        return this._socket;
    }
}

export const testResultServiceSocketIO = new TestResultServiceSocketIO();
